import { faDiamondTurnRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Dropoff } from "../../../models/Dropoff";
import { GateToDropoffRoute } from "../../../models/GateToDropoffRoute";
import { HaulRoute } from "../../../models/HaulRoute";
import WaypointDirections from "../../Map/WaypointDirections";
import DamnMappableAttachments from "../damnMappableAttachments";
import HaulRouteSelector from "./haulRouteSelector";

interface HaulRouteSectionProps {
    haulRoutes: HaulRoute[];
    // May be an archived route that's still assigned to the delivery, which haulRoutes (active-only) won't contain.
    selectedHaulRoute: HaulRoute | null;
    selectedHaulRouteId: number | null;
    saving: boolean;
    onSelect: (haulRoute: HaulRoute) => void;
    // Offered once the haul route's last step is reached, to carry on inside the jobsite.
    gateToDropoffRoutes: GateToDropoffRoute[];
    dropoff: Dropoff | null;
}

const HaulRouteSection: React.FC<HaulRouteSectionProps> = ({
    haulRoutes,
    selectedHaulRoute,
    selectedHaulRouteId,
    saving,
    onSelect,
    gateToDropoffRoutes,
    dropoff,
}) => {
    const routes =
        selectedHaulRoute && !haulRoutes.some((haulRoute) => haulRoute.id === selectedHaulRoute.id)
            ? [...haulRoutes, selectedHaulRoute]
            : haulRoutes;

    if (routes.length === 0) {
        return null;
    }

    return (
        <div className="p-4 bg-gray-50 rounded-lg mx-4">
            <div className="flex flex-row items-start gap-3 px-4 py-3">
                <FontAwesomeIcon icon={faDiamondTurnRight} className="shrink-0 mt-1" size="lg" />
                <div className="flex-1 min-w-0 flex flex-col gap-3">
                    <div className="text-xs text-gray-600 font-medium">
                        Pre-Approved Haul Routes:{" "}
                        {!selectedHaulRoute && <span className="text-red-500">Please select one</span>}
                    </div>
                    <HaulRouteSelector
                        haulRoutes={routes}
                        selectedHaulRouteId={selectedHaulRouteId}
                        disabled={saving}
                        onSelect={onSelect}
                        renderSelected={(haulRoute, button) => (
                            <div className="flex flex-col gap-2">
                                {/* Remounts on each pick (it replaces the bare button), so picking a route opens its steps. */}
                                <WaypointDirections
                                    route={haulRoute}
                                    title={button}
                                    toggleBelowTitle
                                    defaultExpanded
                                    continuationRoutes={gateToDropoffRoutes}
                                    dropoff={dropoff ?? undefined}
                                />
                                <DamnMappableAttachments mappable={haulRoute} />
                            </div>
                        )}
                    />
                </div>
            </div>
        </div>
    );
};

export default HaulRouteSection;
